_ = require 'underscore'
View = require 'views/internal/view'
sidebarAction = require 'views/templates/card_detail_sidebar_button'
{ featureFlagClient } = require 'common/lib/feature-flag-client'

module.exports = class CardLocationButtonView extends View
  initialize: ->
    # TODO: Remove feature flag when Map is shipped. #ECO-LD-MAP
    @mapPowerUpFeatureEnabled = featureFlagClient.get('ecosystem.map_power_up_for_web', false)
    featureFlagClient.on 'ecosystem.map_power_up_for_web', (newVal) =>
      @mapPowerUpFeatureEnabled = newVal
      @renderMapPowerButton()

  tagName: 'span'

  renderMapPowerButton: ->
    @$('.js-edit-location').toggleClass('hide', !@mapPowerUpEnabled())

  mapPowerUpEnabled: ->
    board = @model.getBoard()
    @mapPowerUpFeatureEnabled && board.isMapPowerUpEnabled() && board.editable()

  renderOnce: ->
    locationButtonClass = 'js-edit-location'
    locationButtonClass += ' hide' if !@mapPowerUpEnabled()
    @$el.html(sidebarAction(locationButtonClass, 'location', 'location', true))
    @



// WEBPACK FOOTER //
// ./app/scripts/views/map/card-location-button-view.coffee